<template>
	<div class="checkPasswordStrength">
		<div v-bind:class="[strengthMeterClass]">
			<div v-bind:class="[strengthMeterFillClass]" :data-score="passwordStrength"></div>
		</div>
	</div>
</template>

<script type="text/javascript">
export default {
	props: {
		name: {
			type: String,
			default: 'passwordStrength'
		},
		showTip: {
			type: Boolean,
			default: false
		},
		strengthMeterClass: {
			type: String,
			default: 'Password__strength-meter'
		},
		strengthMeterFillClass: {
			type: String,
			default: 'Password__strength-meter--fill'
		},
		value: {
			type: String
		}
	},
	computed: {
		/**
		 * passwordStrength is the score calculated by criteria
		 * @return {Number} Password Strength Score
		 */
		passwordStrength() {
			return this.value ? this.measureStrength(this.value) : null;
		}
	},
	watch: {
		passwordStrength(score) {
			this.$emit('score', score);
		}
	},
	methods: {
		emitValue(type, value) {
			this.$emit(type, value);
		},
		measureStrength(p) {
			if (!p) return 0;
			var strength = 0;
			if (p.length < 8) return 0;
			if (/[0-9]/.test(p)) strength++;
			if (/[a-z]/.test(p)) strength++;
			if (/[A-Z]/.test(p)) strength++;
			if (
				/[^A-Z-0-9]/i.test(p) &&
				/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?`'"[\]~£€!@$%^:;&_*().></\\§,|±{}+]).{8,}$/.test(p)
			)
				strength++;

			return strength;
		}
	}
};
</script>

<style lang="scss">
[v-cloak] {
	display: none;
}
.Password {
	max-width: 400px;
	margin: 0 auto;
}
.Password__strength-meter {
	position: relative;
	height: 3px;
	background: #ddd;
	margin: 10px auto 20px;
	border-radius: 3px;
}
.Password__strength-meter:before,
.Password__strength-meter:after {
	content: '';
	height: inherit;
	background: transparent;
	display: block;
	border-color: #fff;
	border-style: solid;
	border-width: 0 5px 0 5px;
	position: absolute;
	width: 20%;
	z-index: 10;
}
.Password__strength-meter:before {
	left: 20%;
}
.Password__strength-meter:after {
	right: 20%;
}
.Password__strength-meter--fill {
	background: transparent;
	height: inherit;
	position: absolute;
	width: 0;
	border-radius: inherit;
	transition: width 0.5s ease-in-out, background 0.25s;
}
.Password__strength-meter--fill[data-score='0'] {
	background: darkred;
	width: 20%;
}
.Password__strength-meter--fill[data-score='1'] {
	background: orangered;
	width: 40%;
}
.Password__strength-meter--fill[data-score='2'] {
	background: orange;
	width: 60%;
}
.Password__strength-meter--fill[data-score='3'] {
	background: yellowgreen;
	width: 80%;
}
.Password__strength-meter--fill[data-score='4'] {
	background: green;
	width: 100%;
}
.btn-clean {
	appearance: none;
	background: none;
	border: none;
	cursor: pointer;
	outline: none;
	color: #777777;
	padding: 0;
	svg {
		fill: currentColor;
	}
	&:hover,
	&:focus {
		color: #404b69;
	}
}
</style>
